export class CertificateUserModel {
  name: string;
  surname: string;
  dateOfBirth: string;
}
